import { useEffect, useState } from 'react';

let lastComputedSize: { width: number; height: number }|null = null;

export const useWindowSize = () => {
    const [size, setSize] = useState<{ width: number; height: number }| null>(
        lastComputedSize
    );

    useEffect(() => {
        const handleWindowResize = () => {
            lastComputedSize = {
                width: window.innerWidth,
                height: window.innerHeight,
            };

            setSize(lastComputedSize);
        };

        window.addEventListener('resize', handleWindowResize, {
            passive: true,
        });

        handleWindowResize();

        return () => {
            window.removeEventListener('resize', handleWindowResize, {
                passive: true,
            } as any);
        };
    }, [setSize]);

    return size;
};
